import { SubAccountType as Enum_SubAccountType } from "../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { FrequencyType } from "../../../Wrap/Constants/Enums/Domain/FrequencyType";
import { FrequencyTypeMap } from "../Resoures/Contents";
import { Money } from "../../../Wrap/Core/DataTypes/Money";
import { MoneyDisplayHelper } from "../../../react-core/Helpers/MoneyDisplayHelper";
import { RegularPaymentStatusType } from "../../../Wrap/Constants/Enums/Domain/RegularPaymentStatusType";
import { WithdrawalStatus } from "../../../Wrap/Constants/Enums/Domain/WithdrawalStatus";
import { PaymentMethod } from "../../../Wrap/Constants/Enums/Domain/PaymentMethod";

export class Methods {
    public static getAccountTypeClass(type: string | Enum_SubAccountType): string {
        let _class = " ";
        const dic: any[] = [
            { key: Enum_SubAccountType.StocksIsa, name: "stocksisa", value: "isa" }, ////ISA Stocks & Shares
            { key: Enum_SubAccountType.Npr, name: "npr", value: "sipp" },
            { key: Enum_SubAccountType.Pension, name: "pension", value: "sipp" },
            { key: Enum_SubAccountType.Sipp, name: "sipp", value: "sipp" },
            { key: Enum_SubAccountType.InvestmentAccount, name: "investmentaccount", value: "pp" }, //Personal Portfolio
            { key: Enum_SubAccountType.CashAccount, name: "cashaccount", value: "wrap-cash" },
            { key: Enum_SubAccountType.WrapCash, name: "wrapcash", value: "wrap-cash" },
            { key: Enum_SubAccountType.OffshoreBond, name: "offshorebond", value: "offshore-bond" },
            { key: Enum_SubAccountType.OnshoreBond, name: "onshorebond", value: "onshore-bond" },
            { key: Enum_SubAccountType.CashIsa, name: "cashisa", value: "cash-isa" },
        ];
        _class +=
            typeof type == "string"
                ? dic.filter((x) => x.name == (type + "").toLowerCase())[0].value
                : dic.filter((x) => x.key == type).length > 0
                ? dic.filter((x) => x.key == type)[0].value
                : "";

        return _class;
    }

    public static findParam(from: string, param: string, num: number): number {
        let x = from.indexOf(param);
        for (let i = 0; i < num; i++) {
            x = from.indexOf(param, x + 1);
        }
        return x;
    }

    public static getFormatFrequencyType(frequencyType: FrequencyType): string {
        if (frequencyType === FrequencyType.HalfYearly) {
            return "Half yearly";
        } else if (frequencyType === FrequencyType.NotSpecified) {
            return "N/A";
        } else {
            return FrequencyTypeMap[frequencyType];
        }
    }

    public static getMoneyFormat(
        val: Money,
        needPlus?: boolean,
        isShowCurrency?: boolean,
        decimalCount?: number
    ): string {
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(
            Math.abs(val.Amount),
            val.Currency,
            isShowCurrency,
            decimalCount
        );
        if (MoneyDisplayHelper.getMoneyFormatNoSymbol(val.Amount) < 0) {
            formatMoney = "-" + formatMoney;
        } else if (MoneyDisplayHelper.getMoneyFormatNoSymbol(val.Amount) && needPlus) {
            formatMoney = "+" + formatMoney;
        }

        return formatMoney;
    }

    public static getPercentageFormat(val: number): string {
        return val.toFixed(2) + "%";
    }

    public static getIdFromNeedSplitString(val: string): number {
        if (val.indexOf("-") > 0) {
            return parseInt(val.split("-")[1]);
        } else {
            return parseInt(val);
        }
    }

    public static getProductNameFromUrl(): string {
        const url = window.location.pathname;
        if (url.includes("sipp-")) {
            return "SIPP";
        }
        if (url.includes("isa-")) {
            return "ISA Stocks & Shares";
        }
        if (url.includes("pp-")) {
            return "Personal Portfolio";
        }
        if (url.includes("wrap-cash")) {
            return "Cash Account";
        }
        return "";
    }

    public static getWithdrawalPaymentType(type: RegularPaymentStatusType): string {
        if (type == RegularPaymentStatusType.Authorised) {
            return "Regular Withdrawal";
        }
        return "";
    }

    public static getPayeeReference(val: string): string {
        if (val == "WrapCash") {
            return "Cash Account";
        }
        return val;
    }

    public static getWithdrawalStatus(type: WithdrawalStatus): string {
        if (type == WithdrawalStatus.Active) {
            return "Active";
        } else if (type == WithdrawalStatus.Pending) {
            return "Pending";
        } else if (type == WithdrawalStatus.Historic) {
            return "Historic";
        } else if (type == WithdrawalStatus.Removed) {
            return "Removed";
        } else if (type == WithdrawalStatus.FutureDated) {
            return "FutureDated";
        }
        return "";
    }
    public static getStopDate(status: WithdrawalStatus, date: string): string {
        if (status == WithdrawalStatus.Active) {
            return "";
        } else {
            return date;
        }
    }

    public static getPaymentMethod(type: PaymentMethod): string {
        if (type == PaymentMethod.DirectCredit) {
            return "Direct Credit";
        }
        return "";
    }
}
